import React from "react";
import "../styles/Services.css";

const Services = () => {
  return (
    <section className="services-container" id="services">
      <h3 className="services-title"> Areas Covered </h3>
      <ul className="service-list">
        <li>Edmonton Green</li>
        <li>Wood Green</li>
        <li>Tottenham</li>
      </ul>
      <p className="area">
        Nearby but not listed? <br /> Contact us to check coverage.{" "}
      </p>
    </section>
  );
};

export default Services;
